(function () {
  "use strict";

  var MOBILE_QUERY = "(max-width: 767px)";
  var STORAGE_KEY = "adorablesPriceDetailsCollapsed";

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getStoredCollapsed() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === "true";
    } catch (e) {
      return false;
    }
  }

  function setStoredCollapsed(collapsed) {
    try {
      if (collapsed) window.sessionStorage.setItem(STORAGE_KEY, "true");
      else window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function setExpanded(root, expanded) {
    if (!root) return;
    var toggle = root.querySelector("[data-price-details-toggle]");
    root.classList.toggle("cd-footer__price-card--user-expanded", expanded);
    if (toggle) toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
  }

  function applyDefault(scope) {
    var root = (scope || document).querySelector("[data-price-details]");
    if (!root) return;
    if (!isMobile()) {
      setExpanded(root, true);
      return;
    }
    setExpanded(root, !getStoredCollapsed());
  }

  document.addEventListener("click", function (event) {
    var toggle = event.target.closest && event.target.closest("[data-price-details-toggle]");
    if (!toggle || !isMobile()) return;

    var root = toggle.closest("[data-price-details]");
    if (!root) return;

    var expanded = !root.classList.contains("cd-footer__price-card--user-expanded");
    setExpanded(root, expanded);
    setStoredCollapsed(!expanded);
  });

  function scheduleApply() {
    window.setTimeout(function () {
      applyDefault(document);
    }, 0);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleApply, { once: true });
  } else {
    scheduleApply();
  }

  document.addEventListener("cart:updated", scheduleApply);
  document.addEventListener("cart:refresh", scheduleApply);
  document.addEventListener("shopify:section:load", scheduleApply);
  window.addEventListener("pageshow", scheduleApply);

  var form = document.getElementById("form-mini-cart");
  if (form && window.MutationObserver) {
    new MutationObserver(scheduleApply).observe(form, { childList: true, subtree: true });
  }
})();